/* ============
 * Mutations for the Unit-types module
 * ============
 *
 * The mutations that are available on the
 * Unit-types module.
 */

import {LOAD, LOAD_PANORAMA} from './mutation-types';

/* eslint-disable no-param-reassign */
export default {
  [LOAD](state, unitTypes) {
    state.unitTypes = unitTypes.data;
  },
  [LOAD_PANORAMA](state, { panorama, unitTypeId }) {
    state.typePanoramas[unitTypeId] = panorama.data;
  },
};
